import { render, staticRenderFns } from "./AttrListExtend.vue?vue&type=template&id=f0e32aa0&scoped=true"
import script from "./AttrListExtend.vue?vue&type=script&lang=js"
export * from "./AttrListExtend.vue?vue&type=script&lang=js"
import style0 from "./AttrListExtend.vue?vue&type=style&index=0&id=f0e32aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e32aa0",
  null
  
)

export default component.exports